import { createUseStyles } from '../../theme/theming';
const inputStyles = createUseStyles((theme) => ({
  inputField: {
    width: '100%',
    // maxWidth: '314px',
    // background: theme?.palette?.background?.default,
    border: `1px solid ${theme?.colors?.icon}`,
    borderRadius: theme?.shape?.borderRadius?.regular,
    padding: '14px 12px',
    display: 'flex',
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    verticalalign: 'top',
    resize: 'none',
    fontFamily: 'inherit',
    '&::placeholder': {
      fontWeight: '400',
      fontSize: '16px',
      lineHeight: '20px',
      color: theme?.colors?.black,
      fontFamily: theme?.typography?.fontFamily
    },
    '&:focus': {
      outline: 'none'
    }
  },
  error: {
    borderBottom: '1px solid red',
    position: 'absolute',
    bottom: '-8px',
    width: 'calc(100% - 24px)'
  },

  errorBorder: {
    border: `1px solid red`,
    color: 'red',
    '&::placeholder': {
      color: 'red',
      opacity: '0.5'
    }
  },

  '@media screen and (max-width: 767px)': {
    inputField: {
      width: '100%',
      maxWidth: 'unset'
    },
    error: {
      bottom: '-2px'
    }
  }
}));

export default inputStyles;
